import { getMarketplaceSearchClient } from 'marketplace-ui-common/clients/marketplaceSearchClient';
export const marketplaceAppSearch = ({
  appContext
}, {
  language,
  queries,
  showPreferredLanguageFirst = false
}, opts = {}) => {
  const InAppPublicOnlyContext = appContext === 'app' ? 'app' : 'public';
  const client = getMarketplaceSearchClient(InAppPublicOnlyContext);
  return client.post('apps/search', Object.assign({}, opts, {
    data: {
      language,
      showPreferredLanguageFirst,
      queries
    }
  }));
};